import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//引入公共方法
import methods from "./methods/methods.js";

//引入框架
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

//引入全局权限判断
import usePermission from "./methods/permissionUtils.js";
const {
    hasPermission
} = usePermission();

//引入css样式
import "./assets/css/global.less";

//引入字体
import '@/assets/css/font.css'

//引入组件
import TableList from "./components/TableList.vue";
import SearchForm from "./components/SearchForm.vue";
import SubmitForm from "./components/SubmitForm.vue";
import ImageShow from "@/components/ImageShow.vue";
import Upload from '@/components/Upload.vue'

const app = createApp(App);
app.component("TableList", TableList);
app.component("SearchForm", SearchForm);
app.component("SubmitForm", SubmitForm);
app.component('Upload', Upload);
app.component("ImageShow", ImageShow);

app.config.globalProperties.$methods = methods;
app.config.globalProperties.isPerms = hasPermission;

app.use(store)
app.use(router)
app.use(Antd)
app.mount('#app')


